import React , { useState }from 'react'
import { connect } from 'react-redux'
import { reduxForm, getFormValues, SubmissionError } from 'redux-form'
import { scrollToFirstValidateFailElement } from 'core/utilities'
import { Breadcrumb, Tab, Button ,Icon } from 'semantic-ui-react'
import { MainBodyContent, CustomButton } from 'components'
import { ProcurementContainer, ProcurementBody } from '../../styled'
import { getDownPaymentDetail, getDownPaymentApprover, updateDownPayment, submitDP, initializeDP } from 'ducks/downPayment'
import { downPaymentPath } from 'routes'
import DPStep from './DPStep'
import RequestInformation from './RequestInformation'
import Requestdocument from './Requestdocument'
import Detail from './Detail'
import DPAttachment from './DPAttachment'
import CommentHistory from './CommentHistory'
import r from 'reactotron-react-js'
import { 
  getHrmsMembers,
  getAllMembers 
} from 'ducks/member'

const DownPaymentDisplay = (props) => {
  const { history, dpDetail,
    sapDetails,
    dpActionName,
    valueForm,
    isDetail = true } = props

  React.useEffect(() => {
    props.initializeDP()
    props.getAllMembers(!isDetail)
    // props.getHrmsMembers(!isDetail)
    const { match: { params } } = props
    if (params && params.dpId) {
      props.getDownPaymentDetail(params.dpId)
    }
    return (() => {
    })
  }, [])

  React.useEffect(() => {
    if(props.dpId){
      props.getDownPaymentApprover(props.dpId)
    }
  }, [props.dpId])

  React.useEffect(() => {
    if (sapDetails && sapDetails.companyCode) {
      if (props.projects[sapDetails.companyCode] === undefined) {
        if (sapDetails.companyCode !== props.projectCompanyLoading) {
          props.getProjectByCompany(sapDetails.companyCode)
        }
      }
      props.getPurchaseUsers(sapDetails.companyCode, sapDetails.purchasingGroup)
    }
  }, [sapDetails && sapDetails.companyCode])



  return (
    <MainBodyContent
      headerTitle={<React.Fragment>{dpDetail.isSpecialCreditTerm&&<Icon size='tiny' name='star' color='yellow'/>}{`Down Payment - ${dpDetail.documentNumber ? dpDetail.documentNumber : 'Detail'}`}</React.Fragment>}
      accessoriesHeader={
        <div style={{ display: 'flex' }}>
          {
            dpDetail && dpDetail.urlPrintFormPo &&
            <Button
              basic
              circular
              type='button'
              content='View PO form'
              labelPosition='right'
              icon='clipboard list'
              onClick={() => (window.open(dpDetail.urlPrintFormPo,"_blank"))} />
          }
          <CustomButton
            onClick={() => history.push(downPaymentPath)}
            icon='close'
            btnColor='red'
            title='Close' />
        </div>
      }
      breadcrumbs={
        <Breadcrumb
          icon='right angle'
          sections={[
            { key: 'DOWNPAYMENT', content: 'Down Payment ', link: true, onClick: () => history.push(downPaymentPath) },
            { key: 'DOWNPAYMENT_Detail', content: dpDetail.documentNumber ? dpDetail.documentNumber : 'Detail', active: true }
          ]}
        />
      }
    >
      <ProcurementContainer>
        <ProcurementBody>
          <DPStep />
          <form  >
          {/* onSubmit={props.handleSubmit(() => submitValidate())} */}
            <RequestInformation reqInfo={dpDetail}  />
            {valueForm.sn ?
              <Requestdocument  handleSubmit={props.handleSubmit} history={history} reqInfo={dpDetail} requireInterimPayment={valueForm.requireInterimPayment || false} /> : null
            }
            
            <Tab
              style={{ marginTop: '10px' }}
              menu={{ attached: false }} 
              panes={[
                { menuItem: 'Summary', render: () => <Detail dpDetail={dpDetail} /> },
                { menuItem: 'Attachment', render: () => <DPAttachment dpDetail={dpDetail} /> },
                { menuItem: 'Comment History', render: () => <CommentHistory dpDetail={dpDetail} /> },
              ]}
            />
          </form>
        </ProcurementBody>
      </ProcurementContainer>
    </MainBodyContent>
  )

}

export const validateField = (values, actionName ) => {
  let errors = {}
  if (actionName === 'revise') {
    if (!values.comment) {
      errors.comment = 'Required!'
    }
  }
  if (actionName === 'send') {
    // console.log('Test:'+values.downPaymentProjectOwnerItems)
    if (values.downPaymentProjectOwnerItems.length <= 0) {
      errors.downPaymentProjectOwnerItems = 'Required!'
    }
    if (!values.dueDate) {
      errors.dueDate = 'Required!'
    }
  }
  if (actionName === 'cancel') {
    if (!values.comment) {
      errors.comment = 'Required!'
    }
  }
  if (actionName === 'Revise To Purchase') {
    if (!values.comment) {
      errors.comment = 'Required!'
    }
  }
  if (actionName === 'Revise To Vendor') {
    if (!values.comment) {
      errors.comment = 'Required!'
    }
  }
  if (actionName === 'submit') {
    if (!values.dueDate) {
      errors.dueDate = 'Required!'
    }
    if (!values.paymentType) {
      errors.paymentType = 'Required!'
    }
    if (!values.invoiceNumber) {
      errors.invoiceNumber = 'Required!'
    }
    if (!values.invoiceDate) {
      errors.invoiceDate = 'Required!'
    }
  if (values.statusActivity === 'Procurement Upload Document') {
    if (!values.commentAttachments || !values.commentAttachments.length) {
      errors.commentAttachments = 'Required!'
    }
  }
  if (values.statusActivity === 'Project Owner') {
    if (!values.commentAttachments || !values.commentAttachments.length) {
      errors.commentAttachments = 'Required!'
    }
  }
  
}
return errors
}

const mapStateToProps = (state) => {
  const dpData = state.downPayment.downPaymentDetail
  return ({
    dpDetail: dpData.data,
    dpLoading: dpData.loading,
    dpActionName: state.downPayment.dpActionName,
    initialValues: {
      ...dpData.data,
      withholdingTaxRate: state.downPayment.downPaymentDetail.data.withholdingTaxRate || 0
    },
    dpId: dpData.data.id,
    valueForm: getFormValues('formDP')(state) || {}
  })
}

const mapDispatchToProps = {
  getDownPaymentDetail,
  getDownPaymentApprover,
  updateDownPayment,
  submitDP,
  initializeDP,
  getHrmsMembers,
  getAllMembers
}

const contForm = reduxForm({
  form: 'formDP',
  enableReinitialize: true,
})(DownPaymentDisplay)

export default connect(mapStateToProps, mapDispatchToProps)(contForm)
